import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TExportTable } from 'types/GlobalExportTable'
import { getWithRedirect } from 'utils/axios'
import {
  IExportTablePatchBody,
  IExportTablePostBody,
  TGetOneExportTableResponse
} from './types'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/export-tables`

export async function getAll() {
  return getWithRedirect<TExportTable[]>(URL)
}

export async function getOne(id: string) {
  return getWithRedirect<TGetOneExportTableResponse>(`${URL}/${id}`)
}

export async function create(body: IExportTablePostBody) {
  return axios.post(URL, body, parseAuthenticationHeader())
}

export async function update(id: string, body: IExportTablePatchBody) {
  return axios.patch<{ data: TExportTable }>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export async function assignApiKeys(id: string, apiKeyIds: string[]) {
  return axios.put(
    `${URL}/${id}/assign-api-keys`,
    { data: { api_keys: apiKeyIds } },
    parseAuthenticationHeader()
  )
}
